import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _36ac2b62 = () => interopDefault(import('../pages/Home.vue' /* webpackChunkName: "" */))
const _0de215db = () => interopDefault(import('../modules/storyblok/pages/adresy-sklepow/AddressIndex.vue' /* webpackChunkName: "" */))
const _2cb75568 = () => interopDefault(import('../pages/Authentication.vue' /* webpackChunkName: "" */))
const _413d6de2 = () => interopDefault(import('../modules/storyblok/pages/blog/BlogIndex.vue' /* webpackChunkName: "" */))
const _02086810 = () => interopDefault(import('../pages/Cart.vue' /* webpackChunkName: "" */))
const _7f94dfc6 = () => interopDefault(import('../modules/checkout/pages/Checkout.vue' /* webpackChunkName: "" */))
const _6a6b9402 = () => interopDefault(import('../modules/checkout/pages/Checkout/ShippingAndPayment.vue' /* webpackChunkName: "" */))
const _635ba414 = () => interopDefault(import('../modules/checkout/pages/Checkout/Summary.vue' /* webpackChunkName: "" */))
const _7807e2d7 = () => interopDefault(import('../modules/checkout/pages/Checkout/ThankYou.vue' /* webpackChunkName: "" */))
const _5dd78f50 = () => interopDefault(import('../modules/checkout/pages/Checkout/UserAccount.vue' /* webpackChunkName: "" */))
const _844c1e00 = () => interopDefault(import('../modules/customer/pages/CreatePassword/CreatePassword.vue' /* webpackChunkName: "" */))
const _12d123b8 = () => interopDefault(import('../modules/customer/pages/MyAccount/MyAccount.vue' /* webpackChunkName: "" */))
const _0b8f6992 = () => interopDefault(import('../modules/customer/pages/MyAccount/AddressesDetails/AddressesDetails.vue' /* webpackChunkName: "" */))
const _248e9a9c = () => interopDefault(import('../modules/customer/pages/MyAccount/CaregiverProfile/CaregiverProfile.vue' /* webpackChunkName: "" */))
const _2f26306c = () => interopDefault(import('../modules/customer/pages/MyAccount/MergingAccounts/MergingAccounts.vue' /* webpackChunkName: "" */))
const _58f604e4 = () => interopDefault(import('../modules/customer/pages/MyAccount/MyProfile/MyProfile.vue' /* webpackChunkName: "" */))
const _e76c2c44 = () => interopDefault(import('../modules/customer/pages/MyAccount/MyWishlist.vue' /* webpackChunkName: "" */))
const _44f9f19c = () => interopDefault(import('../modules/customer/pages/MyAccount/NegotiatedOffers/NegotiatedOffers.vue' /* webpackChunkName: "" */))
const _5264dc5c = () => interopDefault(import('../modules/customer/pages/MyAccount/OrderHistory/OrderHistory.vue' /* webpackChunkName: "" */))
const _b33a7844 = () => interopDefault(import('../modules/customer/pages/MyAccount/AddressesDetails/AddressNew.vue' /* webpackChunkName: "" */))
const _7200f366 = () => interopDefault(import('../modules/customer/pages/MyAccount/ResetPassword.vue' /* webpackChunkName: "" */))
const _35fac8bc = () => interopDefault(import('../modules/customer/pages/MyAccount/AddressesDetails/AddressEdit.vue' /* webpackChunkName: "" */))
const _1fe62c3e = () => interopDefault(import('../modules/customer/pages/MyAccount/OrderHistory/SingleOrder/SingleOrder.vue' /* webpackChunkName: "" */))
const _a0293002 = () => interopDefault(import('../modules/storyblok/pages/kariera/KarieraIndex.vue' /* webpackChunkName: "" */))
const _1a570b4d = () => interopDefault(import('../modules/storyblok/pages/kontakt/KontaktIndex.vue' /* webpackChunkName: "" */))
const _34deffff = () => interopDefault(import('../pages/Page.vue' /* webpackChunkName: "pages/Page" */))
const _37917f4a = () => interopDefault(import('../modules/storyblok/pages/PrognozaPogody.vue' /* webpackChunkName: "" */))
const _75f17cf6 = () => interopDefault(import('../modules/storyblok/pages/PrzedstawicieleHandlowi.vue' /* webpackChunkName: "" */))
const _294310d6 = () => interopDefault(import('../modules/request-quote/pages/RequestQuote.vue' /* webpackChunkName: "" */))
const _28f464fe = () => interopDefault(import('../modules/request-quote/pages/ThankYou.vue' /* webpackChunkName: "" */))
const _0bdf9016 = () => interopDefault(import('../modules/storyblok/pages/adresy-sklepow/AddressPage.vue' /* webpackChunkName: "" */))
const _4e59b33c = () => interopDefault(import('../modules/storyblok/pages/blog/BlogPage.vue' /* webpackChunkName: "" */))
const _b699bd58 = () => interopDefault(import('../modules/storyblok/pages/i/StaticPages.vue' /* webpackChunkName: "" */))
const _1fdd2d1c = () => interopDefault(import('../modules/storyblok/pages/kariera/KarieraPage.vue' /* webpackChunkName: "" */))
const _671d2464 = () => interopDefault(import('../modules/storyblok/pages/kontakt/KontaktPage.vue' /* webpackChunkName: "" */))
const _4d4f994a = () => interopDefault(import('../modules/storyblok/pages/p/StaticPages.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/en",
    component: _36ac2b62,
    name: "home___en"
  }, {
    path: "/pl",
    component: _36ac2b62,
    name: "home___pl"
  }, {
    path: "/en/adresy-sklepow",
    component: _0de215db,
    name: "sb-addressPageIndex___en"
  }, {
    path: "/en/authentication",
    component: _2cb75568,
    name: "authentication___en"
  }, {
    path: "/en/Authentication",
    component: _2cb75568,
    name: "Authentication___en"
  }, {
    path: "/en/blog",
    component: _413d6de2,
    name: "sb-blogPageIndex___en"
  }, {
    path: "/en/cart",
    component: _02086810,
    name: "cart___en"
  }, {
    path: "/en/Cart",
    component: _02086810,
    name: "Cart___en"
  }, {
    path: "/en/checkout",
    component: _7f94dfc6,
    name: "checkout___en",
    children: [{
      path: "shipping-and-payment",
      component: _6a6b9402,
      name: "shipping-and-payment___en"
    }, {
      path: "summary",
      component: _635ba414,
      name: "summary___en"
    }, {
      path: "thank-you",
      component: _7807e2d7,
      name: "thank-you___en"
    }, {
      path: "user-account",
      component: _5dd78f50,
      name: "user-account___en"
    }]
  }, {
    path: "/en/create-password",
    component: _844c1e00,
    name: "create-password___en"
  }, {
    path: "/en/customer",
    component: _12d123b8,
    meta: {"titleLabel":"Moje konto"},
    name: "customer___en",
    children: [{
      path: "addresses-details",
      component: _0b8f6992,
      meta: {"titleLabel":"Moje adresy"},
      name: "customer-addresses-details___en"
    }, {
      path: "caregiver-profile",
      component: _248e9a9c,
      meta: {"titleLabel":"Profil opiekuna"},
      name: "customer-caregiver-profile___en"
    }, {
      path: "merging-accounts",
      component: _2f26306c,
      meta: {"titleLabel":"Łączenie kont"},
      name: "customer-merging-accounts___en"
    }, {
      path: "my-profile",
      component: _58f604e4,
      meta: {"titleLabel":"Moje dane"},
      name: "customer-my-profile___en"
    }, {
      path: "my-wishlist",
      component: _e76c2c44,
      meta: {"titleLabel":"Ulubione"},
      name: "customer-my-wishlist___en"
    }, {
      path: "negotiated-offers",
      component: _44f9f19c,
      meta: {"titleLabel":"Negocjowane oferty"},
      name: "customer-negotiated-offers___en"
    }, {
      path: "order-history",
      component: _5264dc5c,
      meta: {"titleLabel":"Historia zakupów"},
      name: "customer-order-history___en"
    }, {
      path: "addresses-details/create",
      component: _b33a7844,
      meta: {"titleLabel":"Moje adresy"},
      name: "customer-addresses-details-new___en"
    }, {
      path: "/en/reset-password",
      component: _7200f366,
      alias: "/customer/account/createPassword",
      name: "reset-password___en"
    }, {
      path: "addresses-details/edit/:addressId",
      component: _35fac8bc,
      meta: {"titleLabel":"Moje adresy"},
      props: true,
      name: "customer-addresses-details-edit___en"
    }, {
      path: "order-history/:orderId",
      component: _1fe62c3e,
      meta: {"titleLabel":"Historia zakupów"},
      props: true,
      name: "customer-single-order___en"
    }]
  }, {
    path: "/en/Home",
    component: _36ac2b62,
    name: "Home___en"
  }, {
    path: "/en/kariera",
    component: _a0293002,
    name: "sb-karieraPageIndex___en"
  }, {
    path: "/en/kontakt",
    component: _1a570b4d,
    name: "sb-kontaktPageIndex___en"
  }, {
    path: "/en/Page",
    component: _34deffff,
    name: "Page___en"
  }, {
    path: "/en/prognoza-pogody",
    component: _37917f4a,
    name: "sb-prognozaPogodyIndexRoute___en"
  }, {
    path: "/en/przedstawiciele-handlowi",
    component: _75f17cf6,
    name: "sb-przedstawicieleHandlowiPageIndex___en"
  }, {
    path: "/en/request-quote",
    component: _294310d6,
    name: "request-quote___en"
  }, {
    path: "/en/request-quote-thank-you",
    component: _28f464fe,
    name: "request-quote-thank-you___en"
  }, {
    path: "/pl/adresy-sklepow",
    component: _0de215db,
    name: "sb-addressPageIndex___pl"
  }, {
    path: "/pl/authentication",
    component: _2cb75568,
    name: "authentication___pl"
  }, {
    path: "/pl/Authentication",
    component: _2cb75568,
    name: "Authentication___pl"
  }, {
    path: "/pl/blog",
    component: _413d6de2,
    name: "sb-blogPageIndex___pl"
  }, {
    path: "/pl/cart",
    component: _02086810,
    name: "cart___pl"
  }, {
    path: "/pl/Cart",
    component: _02086810,
    name: "Cart___pl"
  }, {
    path: "/pl/checkout",
    component: _7f94dfc6,
    name: "checkout___pl",
    children: [{
      path: "shipping-and-payment",
      component: _6a6b9402,
      name: "shipping-and-payment___pl"
    }, {
      path: "summary",
      component: _635ba414,
      name: "summary___pl"
    }, {
      path: "thank-you",
      component: _7807e2d7,
      name: "thank-you___pl"
    }, {
      path: "user-account",
      component: _5dd78f50,
      name: "user-account___pl"
    }]
  }, {
    path: "/pl/create-password",
    component: _844c1e00,
    name: "create-password___pl"
  }, {
    path: "/pl/customer",
    component: _12d123b8,
    meta: {"titleLabel":"Moje konto"},
    name: "customer___pl",
    children: [{
      path: "addresses-details",
      component: _0b8f6992,
      meta: {"titleLabel":"Moje adresy"},
      name: "customer-addresses-details___pl"
    }, {
      path: "caregiver-profile",
      component: _248e9a9c,
      meta: {"titleLabel":"Profil opiekuna"},
      name: "customer-caregiver-profile___pl"
    }, {
      path: "merging-accounts",
      component: _2f26306c,
      meta: {"titleLabel":"Łączenie kont"},
      name: "customer-merging-accounts___pl"
    }, {
      path: "my-profile",
      component: _58f604e4,
      meta: {"titleLabel":"Moje dane"},
      name: "customer-my-profile___pl"
    }, {
      path: "my-wishlist",
      component: _e76c2c44,
      meta: {"titleLabel":"Ulubione"},
      name: "customer-my-wishlist___pl"
    }, {
      path: "negotiated-offers",
      component: _44f9f19c,
      meta: {"titleLabel":"Negocjowane oferty"},
      name: "customer-negotiated-offers___pl"
    }, {
      path: "order-history",
      component: _5264dc5c,
      meta: {"titleLabel":"Historia zakupów"},
      name: "customer-order-history___pl"
    }, {
      path: "addresses-details/create",
      component: _b33a7844,
      meta: {"titleLabel":"Moje adresy"},
      name: "customer-addresses-details-new___pl"
    }, {
      path: "/pl/reset-password",
      component: _7200f366,
      alias: "/customer/account/createPassword",
      name: "reset-password___pl"
    }, {
      path: "addresses-details/edit/:addressId",
      component: _35fac8bc,
      meta: {"titleLabel":"Moje adresy"},
      props: true,
      name: "customer-addresses-details-edit___pl"
    }, {
      path: "order-history/:orderId",
      component: _1fe62c3e,
      meta: {"titleLabel":"Historia zakupów"},
      props: true,
      name: "customer-single-order___pl"
    }]
  }, {
    path: "/pl/Home",
    component: _36ac2b62,
    name: "Home___pl"
  }, {
    path: "/pl/kariera",
    component: _a0293002,
    name: "sb-karieraPageIndex___pl"
  }, {
    path: "/pl/kontakt",
    component: _1a570b4d,
    name: "sb-kontaktPageIndex___pl"
  }, {
    path: "/pl/Page",
    component: _34deffff,
    name: "Page___pl"
  }, {
    path: "/pl/prognoza-pogody",
    component: _37917f4a,
    name: "sb-prognozaPogodyIndexRoute___pl"
  }, {
    path: "/pl/przedstawiciele-handlowi",
    component: _75f17cf6,
    name: "sb-przedstawicieleHandlowiPageIndex___pl"
  }, {
    path: "/pl/request-quote",
    component: _294310d6,
    name: "request-quote___pl"
  }, {
    path: "/pl/request-quote-thank-you",
    component: _28f464fe,
    name: "request-quote-thank-you___pl"
  }, {
    path: "/en/adresy-sklepow/:slug+",
    component: _0bdf9016,
    name: "sb-addressPages___en"
  }, {
    path: "/en/blog/:slug+",
    component: _4e59b33c,
    name: "sb-blogPages___en"
  }, {
    path: "/en/i/:slug+",
    component: _b699bd58,
    name: "sb-staticPagesI___en"
  }, {
    path: "/en/kariera/:slug+",
    component: _1fdd2d1c,
    name: "sb-karieraPages___en"
  }, {
    path: "/en/kontakt/:slug+",
    component: _671d2464,
    name: "sb-kontaktPages___en"
  }, {
    path: "/en/p/:slug+",
    component: _4d4f994a,
    name: "sb-staticPagesP___en"
  }, {
    path: "/pl/adresy-sklepow/:slug+",
    component: _0bdf9016,
    name: "sb-addressPages___pl"
  }, {
    path: "/pl/blog/:slug+",
    component: _4e59b33c,
    name: "sb-blogPages___pl"
  }, {
    path: "/pl/i/:slug+",
    component: _b699bd58,
    name: "sb-staticPagesI___pl"
  }, {
    path: "/pl/kariera/:slug+",
    component: _1fdd2d1c,
    name: "sb-karieraPages___pl"
  }, {
    path: "/pl/kontakt/:slug+",
    component: _671d2464,
    name: "sb-kontaktPages___pl"
  }, {
    path: "/pl/p/:slug+",
    component: _4d4f994a,
    name: "sb-staticPagesP___pl"
  }, {
    path: "/en/:slug+",
    component: _34deffff,
    name: "page___en"
  }, {
    path: "/pl/:slug+",
    component: _34deffff,
    name: "page___pl"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
